export const namespaced = true;

export const state = {
    orders: [],
    order: {},
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_ORDERS(state, orders) {
        state.orders = orders;
    },
    FETCH_ORDER(state, order) {
        state.order = order;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/orders`, {
                params: {
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_ORDERS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchOrder({ commit, state, dispatch }, order_id) {
        try {
            const res = (await axios.get(`/api/admin/orders/${order_id}`)).data;
            commit('FETCH_ORDER', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
        dispatch('fetch');
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        dispatch('fetch');
    },

    async remove({ commit, state, dispatch }, deletes) {

        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-orders`, formDataPost
                    )
                ).data;
                commit('ORDERS_REMOVE');

                dispatch('fetch');

                const notification = {
                    page: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    page: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                page: 'error',
                message: 'Вы не выбрали ни одного заказа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },
}
